var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"printing-headline-root"},[_c('div',{staticClass:"printing-headline-line"}),_c('h2',{staticClass:"printing-headline-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"printing-headline-line"})])}
var staticRenderFns = []

export { render, staticRenderFns }